import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../app-constants';

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {

  constants: any = Constants;

  constructor(private http: HttpClient) { }

  categoria() {
    return this.http.get(`${this.constants.api}/categoria`);
  }

  save(data) {
    return this.http.post(`${this.constants.api}/categoria`, data);
  }

  remove(id) {
    return this.http.delete(`${this.constants.api}/categoria/${id}`);
  }

  edit(data) {
    return this.http.put(`${this.constants.api}/categoria`, data);
  }
}
